import React, { useState, useEffect } from "react";
import { Modal, Button, List, Typography } from "antd";
import { AudioOutlined, BellOutlined, CheckOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import "./index.scss";

const { Text } = Typography;

const PermissionsModal: React.FC<{ visible: boolean; onClose: () => void }> = ({
  visible,
  onClose,
}) => {
  const [permissions, setPermissions] = useState({
    microphone: false,
    notification: false,
  });

  useEffect(() => {
    if (visible) checkPermissions();
  }, [visible]);

  const checkPermissions = async () => {
    navigator.permissions
      ?.query({ name: "microphone" as PermissionName })
      .then((result) => {
        setPermissions((prev) => ({
          ...prev,
          microphone: result.state === "granted",
        }));
      });

    setPermissions((prev) => ({
      ...prev,
      notification: Notification.permission === "granted",
    }));
  };

  const requestMicrophone = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      setPermissions((prev) => ({ ...prev, microphone: true }));
    } catch (error) {
      console.error("Microphone permission denied:", error);
      toast.error("Microphone permission denied");
    }
  };

  const requestNotification = async () => {
    Notification.requestPermission().then((permission) => {
      setPermissions((prev) => ({
        ...prev,
        notification: permission === "granted",
      }));

      if (permission !== "granted") {
        toast.error("Notification Permission Denied");
      }
    });
  };

  const permissionsList = [
    {
      key: "microphone",
      icon: (
        <div className="list-icon-wrapper">
          <AudioOutlined />
        </div>
      ),
      title: "Microphone",
      required: true,
      description:
        "Microphone access is required for calls; without it, calls won’t work.",
      action: requestMicrophone,
      granted: permissions.microphone,
    },
    {
      key: "notification",
      icon: (
        <div className="list-icon-wrapper">
          <BellOutlined />
        </div>
      ),
      title: "Notification",
      required: true,
      description:
        "Efone requires access to send notifications for calling updates and alerts.",
      action: requestNotification,
      granted: permissions.notification,
    },
  ];

  return (
    <Modal
      className="permissions-modal custom-modal"
      title="Permissions"
      open={visible}
      onCancel={onClose}
      footer={null}
    >
      <List
        itemLayout="horizontal"
        dataSource={permissionsList}
        renderItem={(item) => (
          <List.Item
            className="permissions-list"
            actions={[
              !item.granted ? (
                <Button className="allow-btn" type="text" onClick={item.action}>
                  Allow
                </Button>
              ) : (
                <CheckOutlined className="success-icon" />
              ),
            ]}
          >
            <List.Item.Meta
              avatar={<span style={{ fontSize: 20 }}>{item.icon}</span>}
              title={
                <>
                  {item.title} {item.required && <Text type="danger">*</Text>}
                </>
              }
              description={item.description}
            />
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default PermissionsModal;
